<template>
  <div class="nzmWelfareCenter" v-if="data_list && data_list.length > 0">
    <NarBar :navs="navs" :choose="nav_choose" :parent_name="info.act_name_chn"/>

    <div class="welfare_block" v-for="(type_data,idx1) in data_list" :key="'type_'+idx1">
      <Title
        v-if="type_data.title_config"
        :info="type_data.title_config"
        :parent_name="info.act_name_chn"
      />
      <div class="row" v-for="(row_item,idx2) in type_data.benefits" :key="'row_'+idx2">
        <WelfareItem
          :info="item"
          :click_button="item.click_button"
          :click_img="item.click_img"
          v-for="(item,idx3) in row_item"
          :key="'item_'+idx3"
        />
      </div>
    </div>
  </div>
</template>
<script>
import click_handler from "../../tools/mgtv/click";
import { openLink } from "../../tools/mgtv/link";
import { getJSON, getJSONP } from "../../api/myaxios";
import { toRem } from "../../tools/tpl";
import Title from "./Title.vue";
import NarBar from "./NavBar.vue";
import WelfareItem from "./NzmWelfareCenter/WelfareItem.vue";
import { group_by_size } from "../../tools/group";
import process_award from "../../tools/mgtv/process_award";
import { onUseInfoLoad } from "../../tools/onUseInfoLoad";
import { urlToWebp} from "../../tools/tpl";
import {jumpToMoreBenefit } from './NzmBenefit/benefitApi';
import {GET_GIFT} from '../../constant/eventbus'
const JINGXUAN_TYPE = "8";  // 默认上新

export default {
  name: "NzmWelfareCenter",
  components: { Title, NarBar, WelfareItem },
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          act_name: "act_name",
          act_name_chn: "会员福利社",
          wrap_style: {
            paddingTop: "0px"
          },
          title: {
            show: false
          },
          config: {}
        };
      }
    }
  },
  data: function() {
    return {
      navs: [],
      nav_choose: 0,
      data_list: []
    };
  },
  computed: {
    act_name() {
      return this.info.config && this.info.config.moudle_id || this.info.act_name
    }
  },
  methods: {
    get_detail: function(type = JINGXUAN_TYPE) {
      const params = {
        act_name: this.act_name,
        invoker: window.gact.invoker,
        ticket: window.$bus.user.ticket,
        f_release:window.gact.f_release
      };
      params.type = type;
      getJSON(
        "//vipact3.api.mgtv.com/api/v1/act/vipbenefits/list",
        params,
        10000,
        false,
        true
      ).then(res => {
        if (!res) {
          return;
        }
        if (res.ret === 0) {
          //福利项
          const data_list = res.data.list;
          data_list.forEach(item => {
            if (item.benefits) {
              item.benefits.forEach(item2 => {
                item2.head_img = urlToWebp(item2.head_img);

                item2.click_button = () => {
                  this.click_button(item2);
                };
                item2.click_img = () => {
                  this.click_img(item2);
                };
              });
              //2个一行
              item.benefits = group_by_size(item.benefits, 2);
            }
            if (item.name) {
              item.title_config = {
                icon:
                  "https://vipcdn.mgtv.com/upload3/201909/pindao/bar_icon.png",
                title: item.name,
                more_url: `${window.gact.config.moreBenefitUrl}?award_type=${item.type}&version=2`
              };
            }
          });
          this.data_list = data_list;

          //查找当前type在nav中的位置，改变nav中选中状态。
          const nav_choose = this.navs.findIndex(item => {
            return item.id == type;
          });

          if (nav_choose >= 0) {
            this.nav_choose = nav_choose;
          }
        }
      });
    },
    click_button: function(item) {
      if(item.out_stock === 1){
        return;
      }
      const need_vip_level = item.received === 1 ? 0 : item.growth_level; //如果已领取，则不检查等级，否则检查等级
      click_handler(
        `领取福利-${item.award_name}`,
        () => {
          window.$bus.$emit(GET_GIFT, {awardInfo:item, act_name:this.act_name});
        },
        {
          need_login: true,
          need_act: true,
          need_vip_level: need_vip_level
        }
      );
    },
    click_img: function(item) {
      jumpToMoreBenefit(item, this.act_name)
    },
    initNavs() {
    const navs = []
    const t_navs = [
      {
        id: 8,
        title: '上新'
      },
      {
        id: 9,
        title: '数码'
      },
      {
        id: 1,
        title: '美妆'
      },
      {
        id: 2,
        title: '美食'
      },
      {
        id: 3,
        title: '生活'
      },
    ]
    t_navs.map(item => {
        navs.push({
          id:item.id,
          title: item.title,
          handler: () => {
            this.get_detail(item.id);
          }
        });
    })
    this.navs = navs
    },
  },
  created() {
    onUseInfoLoad(() => {
      this.get_detail();
    }, false);
    this.initNavs()
  }
};
</script>


<style lang="stylus" scoped>

.nzmWelfareCenter
  position relative
  width 7.5rem
  .welfare_block
    position relative
    margin-top .3rem
    .row
      display flex
      padding 0 .3rem
      justify-content space-between
      margin-top .2rem

</style>
